exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n * Foundation for Sites by ZURB\n * Version 6.4.1\n * foundation.zurb.com\n * Licensed under MIT Open Source\n */\nform {\n  width: 100%; }\n\nmd-card {\n  background-color: white;\n  width: 100%; }\n\n.example-full-width {\n  width: 100%; }\n\n.grid-x {\n  padding-top: 0.5%;\n  padding-left: 10%;\n  padding-right: 10%;\n  padding-bottom: 3%;\n  background-color: #E4EAED; }\n\n.md-card-body {\n  border: solid 0.5px;\n  border-color: aliceblue;\n  min-height: 420px; }\n\n.md-card-button {\n  background-color: #F9FAFB; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/apply-job-section1/apply-job-section1.component.scss
// module id = 181
// module chunks = 1